import { Card, Col, Divider, Form, Input, Button, Row, Select, message, Checkbox, Alert } from "antd";
import { CheckOutlined, CloseOutlined, DeleteFilled, SelectOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import ConsultHeaderCard from "../../../../components/Common/Cards/ConsultHeaderCard";
import { filterOption, isValidValue, setFormFieldValue } from "../../../../helpers/FormHelper";
import { getErrorMessage } from "../../../../helpers/ErrorHelper";
import { useSelector } from "react-redux";
import DiasporaReferenceService from "../../../../services/Diaspora/DiasporaReferenceService";
import { capitalizeFirstLetter } from "../../../../helpers/StringFormatter";
import { getFullName } from "../../../../helpers/ObjectHelper";
import SelectVoter from "../select-voter";
import { Modal } from "reactstrap";
import moment from "moment";



const rules = {
    voter: [
        {
            required: true,
            message: "Ju lutem zgjidhni votuesin!",
        },
    ],
    country: [
        {
            required: true,
            message: "Ju lutem zgjidhni shtetin!",
        },
    ],
    referenceType: [
        {
            required: true,
            message: "Ju lutem zgjidhni tipin e referencës!",
        },
    ],
    city: [
        {
            required: false,
            message: "Ju lutem plotësoni qytetin!",
        },
    ],
    zip: [
        {
            required: false,
            message: "Ju lutem plotësoni kodin postar!",
        }
    ],
    phone: [
        {
            required: true,
            message: "Ju lutem plotësoni numrin e telefonit!",
        },
    ],
    name: [
        {
            required: true,
            message: "Ju lutem plotësoni emrin",
        },
    ],
    surname: [
        {
            required: false,
            message: "Ju lutem plotësoni mbiemrin",
        },
    ]
};


const initialChecks = {
    perRegistered: false,
    envelopeReceived: false,
    voted: false,
    hasReferues: false,
};



const Add = ({ countries, referenceTypes, onBack, onSuccess }) => {
    const token = useSelector((state) => state.Member.token);
    const [selectedVoter, setSelectedVoter] = useState(null);
    const [voterModal, setVoterModal] = useState(false);
    const [selectedReferenceTypeCode, setSelectedReferenceTypeCode] = useState(null);
    const [checks, setChecks] = useState(initialChecks);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [form] = Form.useForm();


    const isVoterSelected = isValidValue(selectedVoter);
    const hasErrorMessage = isValidValue(errorMessage);


    useEffect(() => {
        form.setFieldsValue({
            name: getFullName(selectedVoter),
            surname: setFormFieldValue(selectedVoter?.surname),
            father_name: setFormFieldValue(selectedVoter?.father_name),
            birthdate: isValidValue(selectedVoter?.dob) ? moment(selectedVoter?.dob).format("DD-MM-YYYY") : null,
            region: setFormFieldValue(selectedVoter?.region?.name),
            municipality: setFormFieldValue(selectedVoter?.municipality?.name),
            unit: setFormFieldValue(selectedVoter?.unit?.name),
        });
    }, [form, selectedVoter]);


    const formatRequestData = (data) => {
        return {
            voter_id: setFormFieldValue(selectedVoter?.id),
            country_id: setFormFieldValue(data?.country),
            emigrant_city: capitalizeFirstLetter(data?.city),
            emigrant_phone: setFormFieldValue(data?.phone),
            zip_code: setFormFieldValue(data?.zip_code),
            note: capitalizeFirstLetter(data?.note),
            per_registered: checks.perRegistered,
            envelope_received: checks.envelopeReceived,
            voted: checks.voted,
            has_referues: checks.hasReferues,
            reference_type: setFormFieldValue(data?.referenceType),
            referues_name: capitalizeFirstLetter(data?.referuesName),
            referues_surname: capitalizeFirstLetter(data?.referuesSurname),
            referues_phone: setFormFieldValue(data?.referuesPhone),
        };
    };


    const onSave = async () => {
        try {
            setSubmitLoading(true);
            const data = await form.validateFields();
            const requestData = formatRequestData(data);
            const response = await DiasporaReferenceService.register(token, requestData);
            const responseData = response.data;
            if (responseData) {
                await message.success('Referenca u shtua me sukses!', 1);
                onSuccess();
            } else {
                const errorMessage = 'Një gabim ndodhi gjatë shtimit të referencës!';
                setErrorMessage(errorMessage);
            }
        } catch (error) {
            if (error?.values) {
                setSubmitLoading(false);
                return;
            }
            const errorMessage = getErrorMessage(error);
            setErrorMessage(errorMessage);
        } finally {
            setSubmitLoading(false);
        }
    };


    const onCheckboxChange = (event, checkType) => {
        const isChecked = event.target.checked;
        setChecks({ ...checks, [checkType]: isChecked });
    };


    const onReferenceTypeChange = (value) => {
        form.setFieldsValue({ referuesName: null, referuesSurname: null, referuesPhone: null });
        const selectedReferenceTypeCode = setFormFieldValue(value);
        setSelectedReferenceTypeCode(selectedReferenceTypeCode);
        const hasReferuesSelected = selectedReferenceTypeCode === "biznesi";
        setChecks({
            ...checks,
            hasReferues: hasReferuesSelected,
        });
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24} className="mb-3">
                    <Col span={24}>
                        <ConsultHeaderCard
                            longTitle="Jeni duke shtuar një reference diaspore të re"
                            shortTitle="Refrencë diaspore e re"
                            onBack={onBack}
                        />
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Card style={{ borderRadius: "0" }}>
                            <Form form={form} labelAlign="left" labelCol={{ span: 8 }} layout="horizontal">
                                <Row gutter={24}>
                                    <Col span={24}>
                                        {/* VOTER */}
                                        <Row gutter={24}>
                                            <Col span={24}>
                                                <Row gutter={24}>
                                                    <Col span={24}>
                                                        <h5 className="font-weight-bold">
                                                            Të dhënat e votuesit
                                                        </h5>
                                                    </Col>
                                                    <Col span={24}>
                                                        <Divider className="w-100 mt-0" />
                                                    </Col>
                                                </Row>
                                                <Row gutter={24} align="top" className="m-0">
                                                    <Col xl={0} lg={0} md={0} sm={12} xs={12} />
                                                    <Col xl={0} lg={0} md={0} sm={12} xs={12}>
                                                        <Form.Item name="selectMember">

                                                            {isVoterSelected === false && (
                                                                <Button
                                                                    ghost
                                                                    block
                                                                    type="primary"
                                                                    icon={<SelectOutlined />}
                                                                    onClick={() => setVoterModal(true)}
                                                                >
                                                                    Zgjidh
                                                                </Button>
                                                            )}

                                                            {isVoterSelected === true && (
                                                                <Button
                                                                    danger
                                                                    block
                                                                    icon={<DeleteFilled />}
                                                                    onClick={() => setSelectedVoter(null)}
                                                                >
                                                                    Zgjidh
                                                                </Button>
                                                            )}

                                                        </Form.Item>
                                                    </Col>
                                                    <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                                                        <Form.Item name="name" label="Emri" rules={rules.voter}>
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                        <Form.Item name="father_name" label="Atësia">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                        <Form.Item name="birthdate" label="Datëlindja">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xl={3} lg={3} md={3} sm={0} xs={0}>
                                                        <Form.Item name="selectMember">

                                                            {isVoterSelected === false && (
                                                                <Button
                                                                    ghost
                                                                    block
                                                                    type="primary"
                                                                    icon={<SelectOutlined />}
                                                                    onClick={() => setVoterModal(true)}
                                                                >
                                                                    Zgjidh
                                                                </Button>
                                                            )}

                                                            {isVoterSelected === true && (
                                                                <Button
                                                                    danger
                                                                    block
                                                                    icon={<DeleteFilled />}
                                                                    onClick={() => setSelectedVoter(null)}
                                                                >
                                                                    Zgjidh
                                                                </Button>
                                                            )}

                                                        </Form.Item>
                                                    </Col>
                                                    <Col xl={1} lg={1} md={24} sm={24} xs={24} />
                                                    <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                                                        <Form.Item name="region" label="Qarku">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                        <Form.Item name="municipality" label="Bashkia">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                        <Form.Item name="unit" label="Nj. administrative">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        {/* EMIGRANT */}
                                        <Row gutter={24} className="mt-4">
                                            <Col span={24}>
                                                <Row gutter={24}>
                                                    <Col span={24}>
                                                        <h5 className="font-weight-bold">
                                                            Të dhëna shtesë
                                                        </h5>
                                                    </Col>
                                                    <Col span={24}>
                                                        <Divider className="w-100 mt-0" />
                                                    </Col>
                                                </Row>
                                                <Row gutter={24} className="m-0">
                                                    <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                                                        <Form.Item name="phone" label="Telefoni" rules={rules.phone}>
                                                            <Input type="text" placeholder="Telefoni..." />
                                                        </Form.Item>
                                                        <Form.Item name="country" label="Shteti i emigrimit" rules={rules.country}>
                                                            <Select
                                                                showSearch
                                                                optionLabelProp="children"
                                                                filterOption={filterOption}
                                                                placeholder="-Zgjidhni shtetin-"
                                                            >
                                                                {countries?.map((item) => (
                                                                    <Select.Option key={item?.id} value={item?.id}>
                                                                        {item?.country_name}
                                                                    </Select.Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                        <Form.Item name="city" label="Qyteti i emigrimit" rules={rules.city}>
                                                            <Input type="text" placeholder="Qyteti..." />
                                                        </Form.Item>
                                                        <Form.Item name="zip_code" label="Kodi postar" rules={rules.zip}>
                                                            <Input type="text" placeholder="ZIP..." />
                                                        </Form.Item>
                                                        <Form.Item name="note" label="Shënime">
                                                            <Input.TextArea rows={4} type="text" placeholder="Shënime..." />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xl={4} lg={4} md={24} sm={24} xs={24} />
                                                    <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                                                        <Form.Item name="perRegistered" label="Regjistruar në PER" labelCol={{ span: 8 }}>
                                                            <Checkbox
                                                                checked={checks.perRegistered}
                                                                onChange={(event) => onCheckboxChange(event, 'perRegistered')}
                                                            />
                                                        </Form.Item>
                                                        <Form.Item name="envelopeReceived" label="Ka marrë zarfin" labelCol={{ span: 8 }}>
                                                            <Checkbox
                                                                checked={checks.envelopeReceived}
                                                                onChange={(event) => onCheckboxChange(event, 'envelopeReceived')}
                                                            />
                                                        </Form.Item>
                                                        <Form.Item name="voted" label="Ka votuar" labelCol={{ span: 8 }}>
                                                            <Checkbox
                                                                checked={checks.voted}
                                                                onChange={(event) => onCheckboxChange(event, 'voted')}
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Row gutter={24}>
                                                    <Col span={24}>
                                                        <Divider className="w-100" />
                                                    </Col>
                                                </Row>
                                                <Row gutter={24} align="top" className="m-0">
                                                    <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                                                        <Form.Item name="referenceType" label="Tipi i referencës" rules={rules.referenceType}>
                                                            <Select
                                                                showSearch
                                                                optionLabelProp="children"
                                                                filterOption={filterOption}
                                                                onChange={onReferenceTypeChange}
                                                                placeholder="-Zgjidhni opsionin-"
                                                            >
                                                                {referenceTypes?.map((item) => (
                                                                    <Select.Option key={item?.id} value={item?.id}>
                                                                        {item?.name}
                                                                    </Select.Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                        <Form.Item name="hasReferues" label="Ka referues">
                                                            <Checkbox
                                                                checked={checks.hasReferues}
                                                                onChange={(event) => onCheckboxChange(event, 'hasReferues')}
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xl={14} lg={14} md={24} sm={24} xs={24} />

                                                    {checks.hasReferues === true && (
                                                        <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                                                            <Form.Item name="referuesName" label="Emri i referuesit" rules={rules.name}>
                                                                <Input type="text" placeholder="Emri..." />
                                                            </Form.Item>
                                                            <Form.Item name="referuesSurname" label="Mbiemri i referuesit" rules={selectedReferenceTypeCode === "biznesi" ? null : rules.surname}>
                                                                <Input type="text" placeholder="Mbiemri..." />
                                                            </Form.Item>
                                                            <Form.Item name="referuesPhone" label="Telefoni i referuesit">
                                                                <Input type="text" placeholder="Telefoni..." />
                                                            </Form.Item>
                                                        </Col>
                                                    )}

                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                {hasErrorMessage === true && (
                                    <Row gutter={24}>
                                        <Col span={24}>
                                            <Row gutter={24}>
                                                <Col span={24}>
                                                    <Divider className="w-100" />
                                                </Col>
                                            </Row>
                                            <Row gutter={24}>
                                                <Col xl={6} lg={6} md={4} sm={0} xs={0} />
                                                <Col xl={12} lg={12} md={16} sm={24} xs={24} className="text-center">
                                                    <Alert
                                                        showIcon
                                                        type="error"
                                                        message={errorMessage}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                )}

                                <Row gutter={24}>
                                    <Col span={24}>
                                        <Divider className="w-100 mt-0" />
                                    </Col>
                                </Row>
                                <Row gutter={24} className="p-2">
                                    <Col xl={8} lg={8} md={4} sm={0} xs={0} />
                                    <Col xl={4} lg={4} md={8} sm={12} xs={12}>
                                        <Button
                                            block
                                            type="primary"
                                            disabled={isVoterSelected === false}
                                            loading={submitLoading}
                                            style={{ height: "37px" }}
                                            icon={<CheckOutlined />}
                                            onClick={onSave}
                                        >
                                            Ruaj
                                        </Button>
                                    </Col>
                                    <Col xl={4} lg={4} md={8} sm={12} xs={12}>
                                        <Button
                                            block
                                            danger
                                            disabled={submitLoading}
                                            style={{ height: "37px" }}
                                            icon={<CloseOutlined />}
                                            onClick={onBack}
                                        >
                                            Mbyll
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Modal
                            centered
                            fade={false}
                            destroyOnClose
                            isOpen={voterModal}
                            modalClassName="p-2"
                            style={{ minWidth: "75%" }}
                            onClosed={() => setVoterModal(false)}
                        >
                            <Row gutter={24} className="p-3" style={{ minHeight: "500px" }}>
                                <Col span={24}>
                                    <SelectVoter
                                        onClose={() => setVoterModal(false)}
                                        selectVoter={(selectedVoter) => { setSelectedVoter(selectedVoter); setVoterModal(false); }}
                                    />
                                </Col>
                            </Row>
                        </Modal>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default Add;